(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-main"] && !Shopify.designMode) return;
  try {
    // Change logo on scroll

  document.addEventListener('DOMContentLoaded', function() {
    const header = document.getElementById('header');
    const brandingWrapper = header.querySelector('.c-site-header__branding');
    const logo = header.querySelector('.c-site-logo');
    const scrolledLogo = header.querySelector('.c-site-logo__scrolled');
    const dummySearchButtons = header.querySelectorAll('.desktop-dummy');
    const searchForms = header.querySelectorAll('.top-search-box');

    function onScroll() {
      if (window.scrollY > 150) {
        if (scrolledLogo) {
          scrolledLogo.classList.remove('u-visually-hidden');
          logo.classList.add('u-visually-hidden');
        }
        header.classList.add('scrolled');
      } else {
        if (scrolledLogo) {
          scrolledLogo.classList.add('u-visually-hidden');
          logo.classList.remove('u-visually-hidden');
        }
        header.classList.remove('scrolled');
      }
    }

    window.addEventListener('scroll', onScroll);
    onScroll(); 

    dummySearchButtons.forEach(function(dummySearchButton, index) {
      
      const searchForm = searchForms[index];
      dummySearchButton.addEventListener('click', function() {
        searchForm.classList.add('active');
        dummySearchButton.classList.add('u-visually-hidden');
      });
    });

    document.addEventListener('click', function(event) {
      searchForms.forEach(function(searchForm, index) {
        const dummySearchButton = dummySearchButtons[index];
        if (!searchForm.contains(event.target) && !dummySearchButton.contains(event.target)) {
          searchForm.classList.remove('active');
          dummySearchButton.classList.remove('u-visually-hidden');
        }
      });
    });

  });
  } catch(e) { console.error(e); }
})();

})();
